import { render, staticRenderFns } from "./Tri.vue?vue&type=template&id=25ad02a4&scoped=true&"
import script from "./Tri.vue?vue&type=script&lang=js&"
export * from "./Tri.vue?vue&type=script&lang=js&"
import style0 from "./Tri.vue?vue&type=style&index=0&id=25ad02a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ad02a4",
  null
  
)

export default component.exports